export const DisputePerspective = Object.freeze({
  CANDIDATE: 'candidate',
  CLIENT: 'client',

  isValidPerspective(value) {
    return [this.CANDIDATE, this.CLIENT].includes(value)
  },
})
